import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import "./InputBox.css"

const InputBox = (props) => {
    const [focus, setFocus] = useState(false);
    const validateInput = () => {
        setFocus(false);
        allValidations();
    }
    const validateMandatory = () => {
        if ((!props.value || props.value === "")) {
            if (!props.mandatoryFields?.includes(props.name)) {
                props.setMandatoryFields && props.setMandatoryFields((prev) => ([...prev, props.name]));
            }
            return props.label + " is mandatory";
        } else {
            let mandatoryFieldsTemp = props.mandatoryFields;
            if (mandatoryFieldsTemp?.length > 0) {
                const index = mandatoryFieldsTemp.indexOf(props.name);
                if (index > -1) {
                    mandatoryFieldsTemp.splice(index, 1);
                }
                props.setMandatoryFields && props.setMandatoryFields(mandatoryFieldsTemp);
            }
            return "";
        }
    }

    const allValidations = async () => {
        let errorMsg = "";
        if (props.required) {
            errorMsg = validateMandatory();
        }
        if (props.value && props.value !== "") {

            if (props.customValidation) {
                errorMsg = await props.customValidation(props.value, props.name);
            }

            if (props.hasOwnProperty("min") && props.value < props.min) {
                errorMsg = "Please enter value greater than or equal to  " + props.min;
            }
            if (props.hasOwnProperty("max") && props.value > props.max) {
                errorMsg = "Please enter value less than or equal to " + props.max;
            }
        }
        if (props.setError) { props.setError((prev) => ({ ...prev, [props.name]: errorMsg })); }
    }

    useEffect(() => {
        if (props.required && (props.value == "" || !props.value) && !props.mandatoryFields?.includes(props.name)) {
            props.setMandatoryFields && props.setMandatoryFields((prev) => ([...prev, props.name]));
        }
    }, []);

    useEffect(() => {
        if (props.submit) {
            props.setFieldCount((prev) => ([...prev, props.name]));
            allValidations();
        }
    }, [props.submit]);

    return (
        <Form.Group className={`g-input`}>
            <Form.Control
                className={`${props.className} ${props.error && props.error[props.name] ? "text-field-with-error" : ""}`}
                {...props}
                onBlur={(e) => { validateInput()}}
                autoComplete="off"
                id={props.id || props.name}
                // value={!props.value ? "" : props.value}
                value={!props.value ? "" :props.formatter?props.formatter(props.value): props.value}
                onFocus={
                    () => { setFocus(true) }}
            />
            <Form.Label className={`${(focus || (props?.value && props?.value != "")) ? "active" : ""} ${props.error && props.error[props.name] ? "text-label-with-error" : ""}`} 
                htmlFor={props.id || props.name}
                onClick={() => document.getElementById(props.id || props.name)?.focus()}
            >
                {props.label}
                {(!props.required && !props.readOnly) && <span className="optional"> (optional)</span>}
            </Form.Label>
            {props.error && props.error[props.name] && (
                <Form.Text className="text-danger">
                    {props.error[props.name]}
                </Form.Text>
            )}
        </Form.Group>
    )
}

export default InputBox;